import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../../core/Evented.js";
import { isNone as t } from "../../../core/maybe.js";
import { EditGeometry as r } from "./EditGeometry.js";
import { AppendVertex as o } from "./operations/AppendVertex.js";
import { UpdateVertices as s } from "./operations/UpdateVertices.js";
import { RemoveVertices as i } from "./operations/RemoveVertices.js";
import { SplitEdge as n } from "./operations/SplitEdge.js";
import { SetVertexPosition as a } from "./operations/SetVertexPosition.js";
import { CloseComponent as p } from "./operations/CloseComponent.js";
import { MoveVertex as d } from "./operations/MoveVertex.js";
import { OffsetEdgeVertex as c } from "./operations/OffsetEdgeVertex.js";
import { RotateVertex as h } from "./operations/RotateVertex.js";
import { ScaleVertex as u } from "./operations/ScaleVertex.js";
import { UndoGroup as m } from "./operations/UndoGroup.js";

var l = /*#__PURE__*/function (_e) {
  _inherits(l, _e);

  var _super = _createSuper(l);

  function l(e) {
    var _this;

    _classCallCheck(this, l);

    _this = _super.call(this), _this.data = e, _this.undoStack = [], _this.redoStack = [], _this.listener = _this.data.on("change", function (e) {
      e.addedVertices && _this.emit("vertex-add", {
        type: "vertex-add",
        vertices: e.addedVertices,
        operation: e.operation
      }), e.removedVertices && _this.emit("vertex-remove", {
        type: "vertex-remove",
        vertices: e.removedVertices,
        operation: e.operation
      }), e.updatedVertices && _this.emit("vertex-update", {
        type: "vertex-update",
        vertices: e.updatedVertices,
        operation: e.operation
      });
    });
    return _this;
  }

  _createClass(l, [{
    key: "destroy",
    value: function destroy() {
      this.listener.remove();
    }
  }, {
    key: "splitEdge",
    value: function splitEdge(e, t) {
      return this.apply(new n(this.data, e, t));
    }
  }, {
    key: "updateVertices",
    value: function updateVertices(e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      return this.apply(new s(this.data, e, t), r);
    }
  }, {
    key: "moveVertices",
    value: function moveVertices(e, t, r, o) {
      var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      return this.updateVertices(e, new d(this.data.coordinateHelper, t, r, o), s);
    }
  }, {
    key: "scaleVertices",
    value: function scaleVertices(e, t, r, o, s) {
      var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
      var n = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
      return this.updateVertices(e, new u(t, r, o, s, n), i);
    }
  }, {
    key: "rotateVertices",
    value: function rotateVertices(e, t, r) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      return this.updateVertices(e, new h(t, r, s), o);
    }
  }, {
    key: "removeVertices",
    value: function removeVertices(e) {
      return this.apply(new i(this.data, e, this._minNumVerticesPerType));
    }
  }, {
    key: "appendVertex",
    value: function appendVertex(e) {
      return 0 === this.data.components.length ? null : this.apply(new o(this.data, this.data.components[0], e));
    }
  }, {
    key: "setVertexPosition",
    value: function setVertexPosition(e, t) {
      return this.apply(new a(this.data, e, t));
    }
  }, {
    key: "offsetEdge",
    value: function offsetEdge(e, t, r) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      return this.updateVertices([t.leftVertex, t.rightVertex], new c(this.data.coordinateHelper, e, t, r), o);
    }
  }, {
    key: "closeComponent",
    value: function closeComponent(e) {
      return this.data.components.includes(e) ? this.apply(new p(this.data, e)) : null;
    }
  }, {
    key: "canRemoveVertex",
    value: function canRemoveVertex() {
      return this.data.components[0].vertices.length > this._minNumVerticesPerType;
    }
  }, {
    key: "createUndoGroup",
    value: function createUndoGroup() {
      var e = new m();
      return this.apply(e), {
        remove: function remove() {
          return e.close();
        }
      };
    }
  }, {
    key: "undo",
    value: function undo() {
      if (this.undoStack.length > 0) {
        var _e2 = this.undoStack.pop();

        return _e2.undo(), this.redoStack.push(_e2), _e2;
      }

      return null;
    }
  }, {
    key: "redo",
    value: function redo() {
      if (this.redoStack.length > 0) {
        var _e3 = this.redoStack.pop();

        return _e3.apply(), this.undoStack.push(_e3), _e3;
      }

      return null;
    }
  }, {
    key: "canUndo",
    get: function get() {
      return this.undoStack.length > 0;
    }
  }, {
    key: "canRedo",
    get: function get() {
      return this.redoStack.length > 0;
    }
  }, {
    key: "lastOperation",
    get: function get() {
      return this.undoStack.length > 0 ? this.undoStack[this.undoStack.length - 1] : null;
    }
  }, {
    key: "_minNumVerticesPerType",
    get: function get() {
      switch (this.data.type) {
        case "point":
          return 1;

        case "polyline":
          return 2;

        case "polygon":
          return 3;

        default:
          return 0;
      }
    }
  }, {
    key: "apply",
    value: function apply(e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return 0 !== r && !t(this.lastOperation) && this.lastOperation.accumulate(e) || (e.apply(), this.undoStack.push(e), this.redoStack = []), e;
    }
  }], [{
    key: "fromGeometry",
    value: function fromGeometry(e, t) {
      return new l(r.fromGeometry(e, t));
    }
  }]);

  return l;
}(e);

export { l as EditGeometryOperations };